import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function DbConf ( props ) {

    return <BasicCrudScreenType id="DbConf" table="DbConf" view="DbConf" />

}

export default DbConf;
